import { WorkspaceMemberRole } from '@up2stay/up2promo-api-client';

/**
 * Whether the actor may persist a role change for this member.
 * Self-demotion (e.g. ADMIN → MEMBER) is allowed; the owner cannot edit
 * their own role (DEV-436).
 */
export function canEditWorkspaceMemberRole(params: {
  canManageRole: boolean;
  memberUserId?: string | null;
  memberRole: WorkspaceMemberRole;
  currentUserId?: string;
  currentUserRole?: WorkspaceMemberRole;
}): boolean {
  if (!params.canManageRole) return false;

  const isSelf =
    Boolean(params.currentUserId) &&
    params.memberUserId === params.currentUserId;

  if (params.memberRole === WorkspaceMemberRole.OWNER) {
    return params.currentUserRole === WorkspaceMemberRole.OWNER && !isSelf;
  }

  return true;
}
